/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingActualDetailConfig } from '../../config/loading.config';
export interface ILoadingActualDetailPluginMethods extends IPluginMethodMap {
  getLoadingActualDetailSync(args?: any): any;
}

export class LoadingActualDetailPlugin implements IAgentPlugin {
  readonly methods: ILoadingActualDetailPluginMethods;

  constructor() {
    this.methods = {
      getLoadingActualDetailSync: this.getLoadingActualDetailSync.bind(this),
    };
  }

  getLoadingActualDetailSync(args?: any) {
    return {
      loading: loadingActualDetailConfig,
    };
  }
}
